<template>
    <div class="klaviyo-form-HgmTNx"></div>
    <!--    <div class="form no-header" v-if="showForm">-->
    <!--        <form :action="dripUrl" method="POST" @submit.prevent="onSubmit">-->
    <!--            <h1>The WaterGuru sensor device will be available for purchase soon. Stay in touch and be the first to become eligible for special introductory offers.</h1>-->
    <!--            <div class="form-group">-->
    <!--                <label class="label-mini" for="first_name">First Name</label>-->
    <!--                <input type="text" id="first_name" name="fields[first_name]" class="form-control"-->
    <!--                       :class="{'is-invalid': errors.has('fields[first_name]')}"-->
    <!--                       v-validate="'required'" v-model="form.first_name">-->

    <!--                <label class="label-mini" for="last_name">Last Name</label>-->
    <!--                <input type="text" id="last_name" name="fields[last_name]" class="form-control"-->
    <!--                       :class="{'is-invalid': errors.has('fields[last_name]')}"-->
    <!--                       v-validate="'required'" v-model="form.last_name">-->

    <!--                <label class="label-mini" for="email">Email</label>-->
    <!--                <input type="email" id="email" name="fields[email]" class="form-control"-->
    <!--                       :class="{'is-invalid': errors.has('fields[email]')}"-->
    <!--                       v-validate="'required|email'" v-model="form.email">-->

    <!--                <label class="label-mini" for="zip">Zip Code</label>-->
    <!--                <input type="number" id="zip" name="fields[zip]" class="form-control"-->
    <!--                       :class="{'is-invalid': errors.has('fields[zip]')}"-->
    <!--                       v-validate="'numeric|min:4|max:5'" v-model="form.zip">-->
    <!--            </div>-->
    <!--            <div class="text-center">-->
    <!--                <w-button class="w-75" :inverse="true">Keep me informed</w-button>-->
    <!--            </div>-->
    <!--        </form>-->
    <!--    </div>-->
    <!--    <div class="thank-you no-header" v-else>-->
    <!--        <div>-->
    <!--            <img src="../assets/img/SENSE_in_pool.png" width="140px" alt="">-->
    <!--            <h1>Thank you!</h1>-->
    <!--            <p>We’ll be in touch soon. If you’re looking for chemical supplies, check out the store.</p>-->
    <!--            <w-button href="https://woo.waterguru.com/" :inverse="true" class="w-75 mb-4">Store</w-button>-->
    <!--            <p>If you have questions, contact us at support@waterguru.com.</p>-->
    <!--        </div>-->
    <!--    </div>-->
</template>

<script>
import { mapActions } from 'vuex'
// import axios from 'axios'

const dripUrl = 'https://www.getdrip.com/forms/281596904/submissions'
// const klaviyo = 'https://a.klaviyo.com'

export default {
    name: 'Lead',
    data () {
        return {
            dripUrl,
            form: {
                first_name: '',
                last_name: '',
                email: '',
                zip: ''
            }
        }
    },
    computed: {
        showForm () {
            return this.$route.params.step === '1'
        }
    },
    methods: {
        ...mapActions({
            spinnerStop: 'spinner/stop'
        }),
        onSubmit (e) {
            e.preventDefault()
            this.$validator.validateAll().then(valid => {
                if (valid) e.target.submit()
                // if (valid) {
                //     axios.get(klaviyo + '/api/v2/lists', {
                //         params: {
                //             api_key: 'pk_055fdc2f39631e7e4acd154e3854ad6dae'
                //         }
                //     }).then(data => console.log(data))
                // }
            })
        }
    },
    mounted () {
        this.spinnerStop()
    },
    updated () {
        this.spinnerStop()
    },
    created () {
        const script = document.createElement('script')
        const head = document.querySelector('head')
        script.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=JYi4Am'
        head.appendChild(script)
    }
}
</script>

<style lang="scss">
    .klaviyo-form-HgmTNx {
        position: fixed;
        top: 0;
        min-height: 100%;
        background-color: #0098c7;
        & > div {
            height: 100% !important;

            & > form {
                padding-top: 44px !important;
                height: 100% !important;

                input {
                    font-size: 16px !important;
                }
            }
        }
    }

    /*.form {*/
    /*    max-width: 530px;*/
    /*    margin: 0 auto;*/
    /*    padding-bottom: 20px;*/
    /*    padding-left: 17px;*/
    /*    padding-right: 17px;*/
    /*}*/

    /*.form h1 {*/
    /*    color: #1A3F65;*/
    /*    font-size: 22px;*/
    /*    font-weight: 600;*/
    /*    padding-left: 18px;*/
    /*    padding-right: 18px;*/
    /*    padding-top: 75px;*/
    /*    margin-bottom: 30px;*/
    /*}*/

    /*!*.form-group {*!*/
    /*!*background-color: #FFF;*!*/
    /*!*padding: 15px 24px 20px 22px;*!*/
    /*!*border-radius: 14px 0 0 14px;*!*/
    /*!*}*!*/

    /*.label-mini {*/
    /*    display: block;*/
    /*    margin-left: 13px;*/
    /*    font-size: 10px;*/
    /*    color: #7B8C9F;*/
    /*    margin-bottom: 0;*/
    /*    margin-top: 19px;*/
    /*}*/

    /*.form-control {*/
    /*    border-top: 0;*/
    /*    border-right: 0;*/
    /*    border-left: 0;*/
    /*    border-radius: 0;*/
    /*    padding-top: 0;*/
    /*    padding-bottom: 0;*/
    /*    height: 22px;*/
    /*    padding-left: 13px;*/
    /*    font-size: 16px;*/
    /*    border-color: #C4CFD5;*/
    /*    color: #1A3F65;*/
    /*}*/

    /*.form-control:focus {*/
    /*    border-color: #23B8DC;*/
    /*    box-shadow: 0 0.2rem 0 0 #23b8dc54;*/
    /*}*/

    /*.form-control.is-invalid:focus {*/
    /*    box-shadow: 0 0.2rem 0 0 #dc354540;*/
    /*}*/

    /*.form-control.is-invalid {*/
    /*    border-color: #dc3545;*/
    /*}*/

    /*.thank-you {*/
    /*    background-image: url('../assets/img/Wave-Background-Ownership-iPhoneX.jpg');*/
    /*    background-position-y: bottom;*/
    /*    background-size: 100%;*/
    /*    text-align: center;*/
    /*    position: fixed;*/
    /*    height: 100%;*/
    /*    width: 100%;*/
    /*    max-width: 530px;*/
    /*    display: flex;*/
    /*    align-items: flex-end;*/
    /*    padding-bottom: 30px;*/
    /*    left: 50%;*/
    /*    transform: translateX(-50%);*/
    /*    color: #fff;*/
    /*}*/

    /*.thank-you img {*/
    /*    position: absolute;*/
    /*    top: 7%;*/
    /*    left: 50%;*/
    /*    transform: translateX(-50%);*/

    /*}*/

    /*.thank-you h1 {*/
    /*    font-family: YummoSemiBold, sans-serif;*/
    /*    margin-bottom: 0;*/
    /*}*/

    /*.thank-you p {*/
    /*    font-size: 18px;*/
    /*}*/
</style>
